require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-glenvill-secures-300-m-non-bank-loan-for-melbourne.json") })
        }
      }, "path---news-glenvill-secures-300-m-non-bank-loan-for-melbourne");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-glenvill-secures-300-m-non-bank-loan-for-melbourne!./.cache/json/news-glenvill-secures-300-m-non-bank-loan-for-melbourne.json
// module id = 818
// module chunks = 231608221292675